var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0a51.2 51.2 0 0 1 51.2 51.2v153.6a51.2 51.2 0 0 1-102.4 0V51.2a51.2 51.2 0 0 1 51.2-51.2z m0 768a51.2 51.2 0 0 1 51.2 51.2v153.6a51.2 51.2 0 0 1-102.4 0v-153.6a51.2 51.2 0 0 1 51.2-51.2z m443.392-512a51.2 51.2 0 0 1-18.7392 69.9392l-133.0176 76.8a51.2 51.2 0 1 1-51.2-88.6784l133.0176-76.8A51.2 51.2 0 0 1 955.392 256zM290.304 640a51.2 51.2 0 0 1-18.7392 69.9392l-133.0176 76.8a51.2 51.2 0 1 1-51.2-88.6784l133.0176-76.8a51.2 51.2 0 0 1 69.9392 18.7392zM955.392 768a51.2 51.2 0 0 1-69.9392 18.7392l-133.0176-76.8a51.2 51.2 0 0 1 51.2-88.6784l133.0176 76.8A51.2 51.2 0 0 1 955.392 768zM290.304 384a51.2 51.2 0 0 1-69.9392 18.7392l-133.0176-76.8a51.2 51.2 0 1 1 51.2-88.6784l133.0176 76.8A51.2 51.2 0 0 1 290.304 384z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadLine);
export default __webpack_public_path__ + "static/media/load-line.85be3c7c023ca8cc08fea74636548693.svg";
export { ForwardRef as ReactComponent };